export function deriveFreeTitle(content) {
  const lines = (content || "").split("\n").map((l) => l.trim()).filter(Boolean);
  if (!lines.length) return "";
  let l = lines.find((x) => x.startsWith("#")) || lines[0];
  l = l.replace(/^#+\s*/, "").replace(/[*_`>]/g, "").trim();
  return l.slice(0, 80);
}
